<template>
    <v-card>
        <v-card-text>
            <experiment-group-task-template-list
                v-if="schemaConfigTaskGroups != null && schemaConfigReadoutGroups != null && mergedTaskTemplates != null"
                :experiment-group="experimentGroup"
                :merged-task-templates="mergedTaskTemplates"
                :task-groups="schemaConfigTaskGroups"
                :readout-groups="schemaConfigReadoutGroups"
                @saved="fetchData"
                @deleted="fetchData"
            />
        </v-card-text>
    </v-card>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { readoutGroupsAPI, SavedReadoutGroup } from "@/services/readoutGroups/readoutGroupsAPI";
import { SavedTaskGroup, taskGroupsAPI } from "@/services/taskGroups/taskGroupsAPI";
import { withLoadingScreen } from "@/lib/loading";
import {
    SavedBaseTaskTemplate,
    SavedExperimentGroupTaskTemplate,
    SavedSchemaConfigTaskTemplate,
    taskTemplatesAPI,
} from "@/services/taskTemplates/taskTemplatesAPI";
import { onMounted } from "vue";
import { ExperimentGroupDTO } from "@/services/experimentGroups/experimentGroupsAPI";
import ExperimentGroupTaskTemplateList from "@/components/ExperimentGroups/ExperimentGroupTaskTemplateList.vue";

const { experimentGroup } = defineProps<{
    experimentGroup: ExperimentGroupDTO;
}>();

const schemaConfigReadoutGroups = ref<SavedReadoutGroup[] | null>();
const schemaConfigTaskGroups = ref<SavedTaskGroup[] | null>();

const schemaConfigTaskTemplates = ref<SavedSchemaConfigTaskTemplate[] | null>();
const experimentGroupTaskTemplates = ref<SavedExperimentGroupTaskTemplate[] | null>();

const mergedTaskTemplates = computed(() => {
   return [
       ...schemaConfigTaskTemplates.value ?? [],
       ...experimentGroupTaskTemplates.value ?? []
   ] as SavedBaseTaskTemplate[];
});

onMounted(() => {
    fetchData();
});

async function fetchData() {
    await withLoadingScreen(async () => {
        const schemaConfigId = experimentGroup.schemaConfig.id;
        const experimentGroupId = experimentGroup.id;

        /*
         Fetch all readout groups, task groups, and task templates for the schema config associated
         to this experiment group
         */
        schemaConfigReadoutGroups.value = await readoutGroupsAPI.bySchemaConfig(schemaConfigId).fetchAll();
        schemaConfigTaskGroups.value = await taskGroupsAPI.bySchemaConfig(schemaConfigId).fetchAll();
        schemaConfigTaskTemplates.value = await taskTemplatesAPI.bySchemaConfig(schemaConfigId).fetchAll();

        /*
         Fetch all task templates for this experiment group
         */
        experimentGroupTaskTemplates.value = await taskTemplatesAPI.byExperimentGroup(experimentGroupId).fetchAll();
    });
}

</script>
